import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorMessageState = (state: RootState) => state.message;

export const selectorMessage = createSelector(
  selectorMessageState,
  (messageState) => messageState
);
